export const CheckIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={12}
      height={9}
      viewBox="0 0 12 9"
      fill="none"
      {...props}
    >
      <path
        fill="#212121"
        fillRule="evenodd"
        d="M11.765.735a.375.375 0 0 1 0 .53l-7 7a.375.375 0 0 1-.53 0l-3.5-3.5a.375.375 0 1 1 .53-.53L4.5 7.47 11.235.735a.375.375 0 0 1 .53 0Z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export const TiltedPinIcon = ({ filled = false, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    transform="rotate(-20)"
    {...props}
  >
    {filled && (
      <path
        fill="#0B0909"
        d="M9 10V5a1 1 0 011-1h4a1 1 0 011 1v5c0 .55.47 1 .95 1.28 1.43.82 2.6 3.24 2.25 4.36-.08.25-.35.36-.62.36H6.42c-.26 0-.54-.11-.62-.36-.34-1.12.82-3.54 2.26-4.36.48-.27.95-.73.95-1.28Z"
      />
    )}
    <path
      stroke="#111928"
      strokeLinecap="round"
      strokeWidth={2}
      d="M12 20v-4M7 4h10M9 5v5c0 .55-.47 1-.95 1.28-1.43.82-2.6 3.24-2.26 4.36.08.25.35.36.62.36h11.17c.27 0 .54-.11.62-.36.35-1.12-.82-3.54-2.26-4.36-.48-.27-.95-.73-.95-1.28V5a1 1 0 00-1-1h-4a1 1 0 00-1 1Z"
    />
  </svg>
);
export const CommonTilesIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={40}
    viewBox="0 0 40 40"
    fill="none"
    {...props}
  >
    <path
      stroke={props.className?.includes("active") ? "#7B61FF" : "#475161"} // Change to purple when active
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M27.125 12.125h-14.25a.75.75 0 0 0-.75.75v14.25c0 .414.336.75.75.75h14.25a.75.75 0 0 0 .75-.75v-14.25a.75.75 0 0 0-.75-.75ZM20 12.125v15.75M27.875 20h-15.75"
    />
  </svg>
);
export const CommonListIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={40}
    viewBox="0 0 40 40"
    fill="none"
    {...props}
  >
    <path
      fill={props.className?.includes("active") ? "#7B61FF" : "#475161"}
      fillRule="evenodd"
      d="M15.688 14c0-.31.251-.563.562-.563h12a.562.562 0 1 1 0 1.126h-12a.562.562 0 0 1-.563-.563ZM15.688 20c0-.31.251-.563.562-.563h12a.562.562 0 1 1 0 1.125h-12a.562.562 0 0 1-.563-.562ZM15.688 26c0-.31.251-.563.562-.563h12a.562.562 0 1 1 0 1.125h-12a.562.562 0 0 1-.563-.562Z"
      clipRule="evenodd"
    />
    <path
      fill={props.className?.includes("active") ? "#7B61FF" : "#475161"}
      d="M12.125 14.938a.937.937 0 1 0 0-1.875.937.937 0 0 0 0 1.874ZM12.125 26.938a.937.937 0 1 0 0-1.875.937.937 0 0 0 0 1.875ZM12.125 20.938a.937.937 0 1 0 0-1.875.937.937 0 0 0 0 1.875Z"
    />
  </svg>
);
export const LoginNudgeIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
    {...props}
  >
    <path
      fill="#0469E3"
      d="M16 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM16 21.75a.75.75 0 0 1-.75-.75v-6a.75.75 0 0 1 1.5 0v6a.75.75 0 0 1-.75.75Z"
    />
    <path
      fill="#0469E3"
      fillRule="evenodd"
      d="M28 16c0 6.627-5.373 12-12 12S4 22.627 4 16 9.373 4 16 4s12 5.373 12 12Zm-1.5 0c0 5.799-4.701 10.5-10.5 10.5S5.5 21.799 5.5 16 10.201 5.5 16 5.5 26.5 10.201 26.5 16Z"
      clipRule="evenodd"
    />
  </svg>
);
export const AssessmentIconDetail = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 49"
    fill="none"
    className={className}
  >
    <path
      fill="#475161"
      fillRule="evenodd"
      d="M15.08 5.326a2.625 2.625 0 0 1 2.347-1.451h10.146c.994 0 1.903.562 2.348 1.451l.774 1.549H36A2.625 2.625 0 0 1 38.625 9.5v17.924a8.625 8.625 0 1 1-8.987 14.701H9A2.625 2.625 0 0 1 6.375 39.5v-30A2.625 2.625 0 0 1 9 6.875h5.305l.774-1.549Zm12.304 34.549a8.625 8.625 0 0 1 8.991-13.296V9.5A.375.375 0 0 0 36 9.125h-4.326c.223 1.517-.943 3-2.601 3H15.927c-1.658 0-2.824-1.483-2.601-3H9a.375.375 0 0 0-.375.375v30c0 .207.168.375.375.375h18.384Zm-9.957-33.75a.375.375 0 0 0-.335.207l-1.5 3a.375.375 0 0 0 .335.543h13.146c.279 0 .46-.293.335-.543l-1.5-3a.375.375 0 0 0-.335-.207H17.427ZM28.125 35a6.375 6.375 0 1 1 12.75 0 6.375 6.375 0 0 1-12.75 0Z"
      clipRule="evenodd"
    />
    <path
      fill="#475161"
      fillRule="evenodd"
      d="M12.375 18.5c0-.621.504-1.125 1.125-1.125h18a1.125 1.125 0 0 1 0 2.25h-18a1.125 1.125 0 0 1-1.125-1.125ZM12.375 24.5c0-.621.504-1.125 1.125-1.125h9a1.125 1.125 0 0 1 0 2.25h-9a1.125 1.125 0 0 1-1.125-1.125ZM38.203 32.621c.485.389.564 1.097.175 1.582l-3 3.75a1.125 1.125 0 0 1-1.502.233l-2.25-1.5a1.125 1.125 0 0 1 1.248-1.872l1.392.928 2.355-2.945a1.125 1.125 0 0 1 1.582-.175Z"
      clipRule="evenodd"
    />
  </svg>
);
export const ChevronLeft = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#FFFFFF"
      d="M13.891 17.418a.697.697 0 0 1 0 .979.68.68 0 0 1-.969 0l-7.83-7.908a.697.697 0 0 1 0-.979l7.83-7.908a.68.68 0 0 1 .969 0 .697.697 0 0 1 0 .979L6.75 10l7.141 7.418z"
    />
  </svg>
);

export const ChevronRight = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={24}
    width={24}
    viewBox="0 0 24 24"
    id="chevron"
    {...props}
  >
    <path
      fill="#FFFFFF"
      d="M13.25 10 6.109 2.58a.697.697 0 0 1 0-.979.68.68 0 0 1 .969 0l7.83 7.908a.697.697 0 0 1 0 .979l-7.83 7.908a.68.68 0 0 1-.969 0 .697.697 0 0 1 0-.979L13.25 10z"
    />
  </svg>
);

export const HatIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      fill="#475161"
      fillRule="evenodd"
      d="M1.63 3.647a.375.375 0 0 0 0 .706l1.495.537v6.101a.36.36 0 0 0 0 .018v2.237c0 .324.225.605.541.675 2.855.634 5.813.634 8.668 0a.691.691 0 0 0 .541-.675V4.89l.993-.357v3.572a.75.75 0 1 0 .75-.009V4c0-.158-.1-.3-.249-.353L8.127 1.404a.375.375 0 0 0-.254 0L1.631 3.647ZM3.876 13.2v-1.688c2.693.792 5.557.792 8.25 0v1.688a19.228 19.228 0 0 1-8.25 0Zm0-2.472c2.686.838 5.564.838 8.25 0V5.159L8.127 6.596a.375.375 0 0 1-.254 0L3.875 5.159v5.568ZM8 5.844 13.133 4 8 2.156 2.866 4 8 5.844Z"
      clipRule="evenodd"
    />
  </svg>
);

export const BreadcrumbMyLearningIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      fill="#475161"
      fillRule="evenodd"
      d="M2 3.814c0-.45.369-.814.824-.814h10.353c.454 0 .823.364.823.814v8.372c0 .45-.369.814-.823.814H2.824A.819.819 0 0 1 2 12.186V3.814Zm.706 0c0-.064.053-.116.118-.116h10.353c.064 0 .117.052.117.116v6.6L11.41 8.552V8.55a.825.825 0 0 0-.905-.179.824.824 0 0 0-.267.179h-.001l-1.21 1.197-.002.001a.118.118 0 0 1-.13.026.118.118 0 0 1-.038-.026l-.002-.001-2.622-2.593a.824.824 0 0 0-.904-.178.824.824 0 0 0-.268.178L2.706 9.483v-5.67Zm0 6.656L5.56 7.648l.002-.002a.118.118 0 0 1 .13-.026.118.118 0 0 1 .038.026l.002.002 2.622 2.592a.824.824 0 0 0 .904.179.824.824 0 0 0 .268-.179v-.001l1.21-1.196.003-.002a.118.118 0 0 1 .167 0l.002.002 2.385 2.357v.786a.117.117 0 0 1-.117.116H2.824a.117.117 0 0 1-.118-.116V10.47Z"
      clipRule="evenodd"
    />
    <path
      fill="#475161"
      d="M9.647 6.953c.325 0 .588-.26.588-.58a.585.585 0 0 0-.588-.582.585.585 0 0 0-.588.581c0 .321.263.581.588.581Z"
    />
  </svg>
);
export const RigthArrowIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M3.188 12.939c0-.31.251-.563.562-.563h16.5a.563.563 0 0 1 0 1.125H3.75a.562.562 0 0 1-.563-.562Z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M13.102 5.791c.22-.22.576-.22.796 0l6.75 6.75c.22.22.22.576 0 .795l-6.75 6.75a.563.563 0 0 1-.796-.795l6.352-6.352-6.352-6.353a.562.562 0 0 1 0-.795Z"
      clipRule="evenodd"
    />
  </svg>
);
export const ChevronRightIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      fill="#CDD8E8"
      d="M5.9 11.633a.617.617 0 0 1-.142-.366.451.451 0 0 1 .142-.35l2.933-2.934-2.95-2.95a.459.459 0 0 1-.125-.358.513.513 0 0 1 .142-.358.47.47 0 0 1 .358-.159.503.503 0 0 1 .342.159l3.317 3.316a.508.508 0 0 1 .116.167.49.49 0 0 1 .034.183.49.49 0 0 1-.034.184.508.508 0 0 1-.116.166l-3.3 3.3c-.1.1-.217.148-.35.142a.617.617 0 0 1-.367-.142Z"
    />
  </svg>
);

export const TickFillIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={25}
    viewBox="0 0 25 25"
    fill="none"
    {...props}
  >
    <path
      fill="#007A52"
      d="M8 15.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Z"
    />
    <path
      fill="#475161"
      fillRule="evenodd"
      d="M8 .969A7.031 7.031 0 1 0 8 15.03 7.031 7.031 0 0 0 8 .97ZM.031 8A7.969 7.969 0 1 1 15.97 8 7.969 7.969 0 0 1 .03 8Z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M11.473 5.812a.469.469 0 0 1-.035.662l-4.169 3.75a.469.469 0 0 1-.627 0l-2.08-1.876a.469.469 0 1 1 .627-.696l1.767 1.592 3.856-3.468a.469.469 0 0 1 .662.036Z"
      clipRule="evenodd"
    />
  </svg>
);

export const TickCourse = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      fill="#007A52"
      d="M10 19a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z"
    />
    <path
      fill="#475161"
      fillRule="evenodd"
      d="M10 1.563a8.438 8.438 0 1 0 0 16.875 8.438 8.438 0 0 0 0-16.875ZM.437 10a9.563 9.563 0 1 1 19.126 0A9.563 9.563 0 0 1 .438 10Z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M14.168 7.374a.563.563 0 0 1-.042.794l-5.003 4.5a.562.562 0 0 1-.752 0l-2.498-2.25a.563.563 0 0 1 .754-.836l2.12 1.911 4.627-4.161a.563.563 0 0 1 .794.042Z"
      clipRule="evenodd"
    />
  </svg>
);

export const BadgeAssessmentIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={48}
    height={48}
    viewBox="0 0 48 48"
    fill="none"
    {...props}
  >
    <path
      fill="#475161"
      d="M24.01 28.134c-5.56 0-10.081-4.402-10.081-9.817S18.449 8.5 24.009 8.5c5.56 0 10.08 4.402 10.08 9.817s-4.52 9.817-10.08 9.817Zm0-17.278c-4.225 0-7.662 3.347-7.662 7.461 0 4.114 3.437 7.461 7.661 7.461 4.225 0 7.661-3.347 7.661-7.461 0-4.114-3.436-7.461-7.66-7.461Zm20 27.08L37.976 27.76c.558-.97.504-2.111.45-3.13-.031-.638-.069-1.3.076-1.727.13-.39.545-.886.945-1.365.743-.893 1.588-1.902 1.588-3.221 0-1.323-.845-2.332-1.588-3.222-.4-.478-.813-.972-.945-1.365-.142-.426-.107-1.09-.076-1.727.057-1.126.123-2.402-.645-3.433-.778-1.037-2.051-1.372-3.176-1.663-.63-.166-1.282-.334-1.644-.592-.353-.252-.715-.798-1.065-1.322-.636-.958-1.357-2.044-2.627-2.446-1.225-.386-2.438.065-3.512.464-.624.233-1.27.472-1.752.472-.479 0-1.124-.24-1.751-.472-1.071-.4-2.287-.85-3.513-.464-1.27.402-1.99 1.488-2.627 2.446-.35.527-.712 1.07-1.064 1.325-.363.258-1.015.426-1.645.592-1.124.291-2.397.626-3.175 1.663-.769 1.03-.703 2.307-.646 3.433.032.638.07 1.3-.076 1.727-.129.39-.544.887-.945 1.365-.746.89-1.59 1.902-1.59 3.222 0 1.322.844 2.331 1.587 3.221.4.479.813.973.945 1.365.142.43.107 1.09.076 1.73-.054 1.02-.107 2.157.454 3.127l-6.033 10.18c-.224.377-.217.84.019 1.208s.665.583 1.106.555l6.448-.405 2.863 5.642c.199.39.599.642 1.046.657h.038a1.22 1.22 0 0 0 1.049-.59l6.996-11.798c.155-.03.3-.052.432-.052s.28.021.431.052l6.997 11.799a1.22 1.22 0 0 0 1.049.589h.038a1.215 1.215 0 0 0 1.045-.657l2.864-5.642 6.448.405a1.22 1.22 0 0 0 1.106-.555c.236-.368.242-.834.019-1.209l.012-.006Zm-28.392 3.982-2.221-4.371a1.22 1.22 0 0 0-1.162-.654l-5 .313 4.703-7.934c.486.193.993.328 1.471.454.63.166 1.282.334 1.645.592.353.252.715.795 1.065 1.322.636.96 1.357 2.047 2.627 2.446.485.153.97.171 1.443.116l-4.575 7.713.004.003Zm6.88-10.87c-.042.01-.08.025-.117.037-.34.105-.671.221-.983.338-.73.273-1.49.555-1.903.423-.453-.144-.904-.825-1.342-1.485-.469-.708-.957-1.439-1.672-1.948-.725-.515-1.597-.742-2.442-.963-.67-.175-1.36-.356-1.71-.642-.013-.012-.022-.024-.038-.036a.598.598 0 0 1-.098-.101c-.264-.356-.223-1.154-.185-1.927.044-.853.09-1.737-.19-2.574-.27-.81-.828-1.479-1.367-2.123-.513-.614-1.045-1.252-1.045-1.733 0-.482.532-1.12 1.045-1.737.542-.644 1.1-1.316 1.368-2.123.28-.84.233-1.721.189-2.574-.041-.773-.082-1.57.185-1.927.274-.365 1.072-.573 1.843-.776.845-.22 1.717-.448 2.442-.963.718-.51 1.203-1.24 1.672-1.948.438-.66.892-1.34 1.342-1.485.413-.132 1.169.15 1.9.423.79.295 1.688.63 2.611.63.926 0 1.82-.335 2.612-.63.73-.273 1.487-.555 1.9-.423.453.144.903.825 1.341 1.485.47.708.958 1.442 1.673 1.948.728.515 1.597.742 2.441.963.772.203 1.572.408 1.843.773.264.356.224 1.157.186 1.927-.044.853-.092 1.736.189 2.574.27.81.828 1.479 1.367 2.123.513.614 1.046 1.252 1.046 1.733 0 .485-.533 1.12-1.046 1.734-.542.647-1.1 1.316-1.367 2.123-.28.84-.233 1.72-.19 2.574.042.773.083 1.57-.185 1.926-.274.365-1.071.574-1.843.776-.844.218-1.714.448-2.441.964-.718.51-1.203 1.24-1.673 1.948-.438.66-.891 1.34-1.342 1.485-.412.132-1.168-.15-1.9-.424a17.257 17.257 0 0 0-.982-.337c-.041-.012-.079-.028-.12-.037-.488-.144-.992-.251-1.512-.251s-1.024.107-1.512.251l.01.01Zm13.287 5.845a1.226 1.226 0 0 0-1.162.653l-2.221 4.372-4.577-7.722c.154.019.308.04.463.04.324 0 .655-.043.986-.147 1.27-.402 1.99-1.488 2.627-2.445.35-.528.712-1.071 1.064-1.323.363-.257 1.015-.426 1.642-.592.482-.126.989-.264 1.47-.454l4.704 7.934-5-.313.004-.003Z"
    />
  </svg>
);

export const BadgeIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.00241 9.37895C6.14912 9.37895 4.64232 7.91144 4.64232 6.10648C4.64232 4.30152 6.14912 2.83402 8.00241 2.83402C9.85571 2.83402 11.3625 4.30152 11.3625 6.10648C11.3625 7.91144 9.85571 9.37895 8.00241 9.37895ZM8.00241 3.61941C6.59432 3.61941 5.44874 4.73511 5.44874 6.10648C5.44874 7.47786 6.59432 8.59356 8.00241 8.59356C9.41051 8.59356 10.5561 7.47786 10.5561 6.10648C10.5561 4.73511 9.41051 3.61941 8.00241 3.61941ZM14.6691 12.6462L12.6583 9.25407C12.8442 8.93091 12.8263 8.55049 12.8084 8.21097C12.7979 7.99826 12.7853 7.77738 12.8337 7.63522C12.8767 7.50535 13.0153 7.33968 13.1487 7.18014C13.3965 6.88256 13.6779 6.54609 13.6779 6.10635C13.6779 5.66559 13.3965 5.32913 13.1487 5.03256C13.0153 4.87303 12.8778 4.70838 12.8337 4.57748C12.7864 4.43533 12.798 4.21445 12.8084 4.00174C12.8274 3.62643 12.8494 3.20101 12.5932 2.8574C12.3338 2.51175 11.9096 2.40027 11.5348 2.30312C11.3248 2.2479 11.1074 2.19165 10.9866 2.10575C10.869 2.02189 10.7483 1.83987 10.6317 1.66499C10.4196 1.34591 10.1792 0.983895 9.75601 0.849933C9.34756 0.721079 8.9433 0.871409 8.58522 1.00435C8.37731 1.08207 8.16206 1.16184 8.00139 1.16184C7.84179 1.16184 7.62654 1.08207 7.41757 1.00435C7.06057 0.871408 6.65526 0.721087 6.24678 0.849933C5.82362 0.9839 5.58315 1.34591 5.37106 1.66499C5.25451 1.84088 5.13375 2.02189 5.01615 2.10677C4.8954 2.19267 4.67804 2.24892 4.46802 2.30414C4.09317 2.40129 3.66894 2.51276 3.40959 2.85842C3.15339 3.20203 3.17544 3.62745 3.19434 4.00276C3.20484 4.21547 3.21744 4.43635 3.16914 4.5785C3.12609 4.70838 2.98748 4.87405 2.85412 5.03359C2.60527 5.33015 2.32385 5.66763 2.32385 6.10737C2.32385 6.54813 2.60526 6.8846 2.85307 7.18116C2.98643 7.34069 3.12398 7.50534 3.16809 7.63624C3.21534 7.77941 3.20379 7.99928 3.19329 8.21301C3.17544 8.55253 3.15759 8.93193 3.34449 9.25509L1.33368 12.6482C1.25913 12.774 1.26123 12.9284 1.33998 13.0512C1.41873 13.1739 1.56154 13.2455 1.70854 13.2363L3.85795 13.1013L4.81244 14.9819C4.87859 15.1118 5.01194 15.1957 5.16105 15.2008H5.17365C5.31751 15.2008 5.45085 15.1261 5.52332 15.0044L7.85544 11.0715C7.90689 11.0612 7.95519 11.0541 7.9993 11.0541C8.0434 11.0541 8.09275 11.0612 8.14315 11.0715L10.4753 15.0044C10.5477 15.1261 10.6811 15.2008 10.8249 15.2008H10.8375C10.9866 15.1957 11.12 15.1118 11.1862 14.9819L12.1406 13.1013L14.2901 13.2363C14.4381 13.2455 14.5799 13.1749 14.6586 13.0512C14.7374 12.9285 14.7395 12.773 14.6649 12.6482L14.6691 12.6462ZM5.2052 13.9736L4.46493 12.5163C4.39248 12.3742 4.24022 12.2893 4.07747 12.2985L2.41108 12.4028L3.97877 9.75811C4.14047 9.82254 4.30953 9.86753 4.46912 9.90946C4.67913 9.96469 4.89647 10.0209 5.01725 10.1068C5.13485 10.1907 5.25561 10.3717 5.37216 10.5476C5.58426 10.8677 5.82472 11.2297 6.24788 11.3626C6.40958 11.4138 6.57128 11.4199 6.7288 11.4015L5.20415 13.9724L5.2052 13.9736ZM7.49845 10.3503C7.4848 10.3534 7.4722 10.3585 7.4596 10.3626C7.3462 10.3973 7.23595 10.4362 7.13198 10.4751C6.88837 10.5661 6.6353 10.6602 6.49775 10.6162C6.34655 10.5681 6.19639 10.3411 6.05043 10.1212C5.89398 9.885 5.73122 9.64162 5.49287 9.47184C5.25136 9.30004 4.9605 9.22436 4.67911 9.15072C4.45545 9.09243 4.2255 9.03209 4.10894 8.93699C4.10474 8.93289 4.10159 8.9288 4.09634 8.92471C4.08479 8.91449 4.07219 8.90324 4.06379 8.89097C3.97559 8.77234 3.98924 8.50644 4.00184 8.24875C4.01654 7.96447 4.03229 7.66994 3.93883 7.39076C3.84853 7.1208 3.66269 6.89785 3.48313 6.6831C3.31197 6.47857 3.13451 6.26585 3.13451 6.10531C3.13451 5.94478 3.31197 5.73204 3.48313 5.52651C3.66373 5.31175 3.84959 5.08779 3.93883 4.81884C4.03229 4.53864 4.01654 4.24514 4.00184 3.96085C3.98819 3.70315 3.97454 3.43726 4.06379 3.31864C4.15514 3.19695 4.42079 3.1274 4.67807 3.05991C4.95948 2.98628 5.25033 2.9106 5.49183 2.73879C5.73124 2.56903 5.89295 2.32565 6.04939 2.0894C6.19535 1.86953 6.34656 1.64251 6.49672 1.59445C6.63427 1.55047 6.88627 1.64456 7.12989 1.73557C7.39345 1.83375 7.69272 1.94521 8.00037 1.94521C8.30907 1.94521 8.60729 1.83375 8.87085 1.73557C9.11446 1.64456 9.36648 1.55047 9.50403 1.59445C9.65523 1.64251 9.80539 1.86954 9.95135 2.0894C10.1078 2.32563 10.2706 2.57004 10.5089 2.73879C10.7515 2.91059 11.0413 2.98627 11.3227 3.05991C11.5799 3.1274 11.8466 3.19592 11.937 3.31762C12.0252 3.43624 12.0115 3.70317 11.9989 3.95983C11.9842 4.24412 11.9685 4.53864 12.0619 4.81782C12.1522 5.08779 12.3381 5.31073 12.5176 5.52548C12.6888 5.73001 12.8662 5.94274 12.8662 6.10327C12.8662 6.26485 12.6888 6.47654 12.5176 6.68106C12.337 6.89684 12.1511 7.11978 12.0619 7.38872C11.9685 7.66892 11.9842 7.96242 11.9989 8.24671C12.0126 8.50442 12.0262 8.7703 11.937 8.88892C11.8456 9.01062 11.5799 9.08016 11.3227 9.14765C11.0413 9.22026 10.7515 9.29696 10.5089 9.46877C10.2695 9.63853 10.1078 9.88192 9.95135 10.1182C9.8054 10.338 9.65418 10.565 9.50403 10.6131C9.36647 10.6571 9.11447 10.563 8.87085 10.472C8.7669 10.4331 8.65664 10.3943 8.54323 10.3595C8.52958 10.3554 8.51698 10.3503 8.50333 10.3472C8.34057 10.2992 8.17256 10.2634 7.99931 10.2634C7.82607 10.2634 7.65806 10.2992 7.4953 10.3472L7.49845 10.3503ZM11.9276 12.2984C11.7669 12.2892 11.6126 12.3741 11.5401 12.5163L10.7999 13.9735L9.27417 11.3995C9.32562 11.4057 9.37707 11.4128 9.42852 11.4128C9.53668 11.4128 9.64693 11.3985 9.7572 11.3637C10.1804 11.2298 10.4208 10.8678 10.6329 10.5487C10.7495 10.3728 10.8702 10.1918 10.9878 10.1079C11.1086 10.022 11.3259 9.96578 11.5349 9.91055C11.6956 9.86862 11.8646 9.82261 12.0253 9.7592L13.5929 12.4039L11.9266 12.2996L11.9276 12.2984Z"
        fill="black"
      />
    </svg>
  );
};

export const RightTickIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill="#007A52"
      d="M16.56 8.454a.75.75 0 0 1 1.061 1.06l-6.107 6.107a.75.75 0 0 1-1.06 0L7.47 12.637a.75.75 0 0 1 1.06-1.06l2.454 2.453 5.577-5.576Z"
    />
    <path
      fill="#007A52"
      fillRule="evenodd"
      d="M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12Zm-1.5 0c0 5.799-4.701 10.5-10.5 10.5S1.5 17.799 1.5 12 6.201 1.5 12 1.5 22.5 6.201 22.5 12Z"
      clipRule="evenodd"
    />
  </svg>
);
export const BookMarkStarIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={22}
    viewBox="0 0 22 22"
    fill="none"
    {...props}
  >
    <path
      fill="#6C5CE7"
      fillRule="evenodd"
      d="M10.223.942a1.32 1.32 0 0 1 1.555 0c.223.162.39.388.481.646l2.06 5.393.005.012a.244.244 0 0 0 .08.112c.034.026.071.04.108.042h.004l5.531.37c.636.043 1.059.495 1.205.986a1.424 1.424 0 0 1-.425 1.492l-4.236 3.674-.002.001a.287.287 0 0 0-.086.132.317.317 0 0 0-.006.168l1.368 5.592a1.42 1.42 0 0 1-.493 1.462 1.303 1.303 0 0 1-1.543.068l-.001-.001-4.725-3.119A.187.187 0 0 0 11 17.94c-.034 0-.07.01-.102.032h-.001l-4.396 2.894v.001a1.441 1.441 0 0 1-1.714-.076 1.589 1.589 0 0 1-.549-1.639l1.265-5.181v-.001a.318.318 0 0 0-.006-.168.287.287 0 0 0-.085-.132l-.002-.001-4.237-3.674A1.425 1.425 0 0 1 .75 8.503c.146-.49.568-.943 1.204-.986l5.535-.37a.198.198 0 0 0 .109-.042.244.244 0 0 0 .08-.112l.004-.012 2.06-5.393c.092-.258.259-.484.482-.646Zm.777.87a.196.196 0 0 0-.115.04.243.243 0 0 0-.09.131L8.733 7.377c-.089.245-.244.46-.451.62-.21.16-.46.256-.725.272l-5.53.37c-.085.006-.164.06-.201.185a.3.3 0 0 0 .081.32h.001l4.236 3.673.001.001c.199.171.345.395.423.644.08.25.089.516.028.77v.003L5.33 19.42c-.053.213.03.389.154.488.12.094.26.109.395.02l4.397-2.895.001-.001a1.31 1.31 0 0 1 1.445 0l4.723 3.118c.05.033.09.038.118.036a.207.207 0 0 0 .112-.047.295.295 0 0 0 .097-.31m0 0-1.37-5.595v-.003c-.06-.254-.051-.52.028-.77s.225-.473.423-.644h.001l4.237-3.674a.3.3 0 0 0 .082-.32c-.037-.124-.116-.179-.202-.184l-5.528-.37h-.002a1.323 1.323 0 0 1-.724-.273 1.369 1.369 0 0 1-.451-.62l-2.061-5.394a.244.244 0 0 0-.09-.132.195.195 0 0 0-.116-.038"
      clipRule="evenodd"
    />
  </svg>
);

export const BookmarkStarGrey = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      fill="#475161"
      fillRule="evenodd"
      d="M9.353 1.618a1.1 1.1 0 0 1 1.296 0c.185.135.324.324.401.539l1.717 4.494.003.01c.014.04.039.071.067.093.028.022.06.033.09.035h.003l4.61.309c.53.035.882.412 1.004.82.12.407.036.908-.354 1.245l-3.53 3.06-.002.002a.24.24 0 0 0-.071.11.263.263 0 0 0-.006.14l1.14 4.66c.12.492-.073.953-.41 1.219-.343.269-.846.345-1.286.056h-.001l-3.938-2.6a.155.155 0 0 0-.085-.026.154.154 0 0 0-.086.026L6.25 18.223a1.2 1.2 0 0 1-1.428-.063 1.324 1.324 0 0 1-.457-1.365l1.054-4.318v-.001a.265.265 0 0 0-.005-.14.24.24 0 0 0-.071-.11l-.002-.001-3.53-3.061a1.187 1.187 0 0 1-.354-1.244c.121-.409.473-.786 1.003-.821l4.613-.31a.165.165 0 0 0 .09-.034.204.204 0 0 0 .067-.093l.004-.01L8.95 2.157a1.14 1.14 0 0 1 .402-.539Zm.648.726a.163.163 0 0 0-.096.032.203.203 0 0 0-.076.11L8.112 6.98a1.14 1.14 0 0 1-.376.516 1.102 1.102 0 0 1-.604.227l-4.608.309c-.07.005-.137.05-.168.153a.25.25 0 0 0 .068.267h.001l3.53 3.061v.001c.166.143.288.33.353.537.066.207.074.43.024.641v.003l-1.056 4.321a.387.387 0 0 0 .129.407c.1.079.216.09.33.016l3.663-2.412H9.4a1.092 1.092 0 0 1 1.204 0l3.936 2.598a.156.156 0 0 0 .098.03.172.172 0 0 0 .093-.039.246.246 0 0 0 .081-.26m0 0-1.14-4.661-.001-.003a1.202 1.202 0 0 1 .023-.641c.066-.208.187-.394.353-.537l3.531-3.062a.25.25 0 0 0 .068-.267c-.03-.103-.097-.148-.168-.153l-4.606-.308h-.002a1.102 1.102 0 0 1-.604-.228 1.141 1.141 0 0 1-.376-.516l-1.717-4.495a.204.204 0 0 0-.075-.11.163.163 0 0 0-.096-.032"
      clipRule="evenodd"
    />
  </svg>
);

export const BookmarkStartFill = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      fill="#475161"
      d="m10.207 15.575 4.165 2.75c.537.351 1.198-.173 1.04-.817l-1.206-4.93a.776.776 0 0 1 .015-.415.749.749 0 0 1 .225-.342l3.735-3.238c.487-.421.24-1.271-.397-1.314l-4.875-.327a.67.67 0 0 1-.368-.138.711.711 0 0 1-.235-.326L10.488 1.72a.71.71 0 0 0-.25-.34.668.668 0 0 0-.788 0 .71.71 0 0 0-.25.34L7.38 6.48a.711.711 0 0 1-.235.325.67.67 0 0 1-.368.138l-4.875.327c-.636.043-.884.893-.396 1.314L5.24 11.82c.105.09.183.209.225.342a.776.776 0 0 1 .015.414l-1.115 4.57c-.19.774.603 1.4 1.239.98l3.875-2.552a.659.659 0 0 1 .727 0Z"
    />
  </svg>
);

export const SmallShareIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      fill="#475161"
      fillRule="evenodd"
      d="M13.75 7.344a2.961 2.961 0 0 1-2.212-.99L7.72 8.809c.16.365.249.768.249 1.192 0 .424-.09.827-.25 1.192l3.819 2.453a2.969 2.969 0 1 1-.508.788L7.212 11.98a2.969 2.969 0 1 1 0-3.96l3.818-2.453a2.969 2.969 0 1 1 2.72 1.777Zm-2.031-2.969a2.031 2.031 0 1 1 4.062 0 2.031 2.031 0 0 1-4.062 0Zm-4.992 6.694a.488.488 0 0 0-.037.058 2.031 2.031 0 1 1 .037-.058Zm5.295 3.488a2.031 2.031 0 1 0 3.456 2.137 2.031 2.031 0 0 0-3.456-2.137Z"
      clipRule="evenodd"
    />
  </svg>
);
export const LoginCrossIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill="#475161"
      d="M19.148 5.648a.562.562 0 1 0-.796-.796L12 11.204 5.648 4.852a.563.563 0 0 0-.796.796L11.204 12l-6.352 6.352a.562.562 0 1 0 .796.796L12 12.796l6.352 6.352a.562.562 0 1 0 .796-.796L12.796 12l6.352-6.352Z"
    />
  </svg>
);
export const BookMarkStarFillIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={22}
    viewBox="0 0 22 22"
    fill="none"
    {...props}
  >
    <path
      fill="#475161"
      fillRule="evenodd"
      d="M10.223.942a1.32 1.32 0 0 1 1.555 0c.223.162.39.388.481.646l2.06 5.393.005.012a.244.244 0 0 0 .08.112c.034.026.071.04.108.042h.004l5.531.37c.636.043 1.059.495 1.205.986a1.424 1.424 0 0 1-.425 1.492l-4.236 3.674-.002.001a.287.287 0 0 0-.086.132.317.317 0 0 0-.006.168l1.368 5.592a1.42 1.42 0 0 1-.493 1.462 1.303 1.303 0 0 1-1.543.068l-.001-.001-4.725-3.119A.187.187 0 0 0 11 17.94c-.034 0-.07.01-.102.032h-.001l-4.396 2.894v.001a1.441 1.441 0 0 1-1.714-.076 1.589 1.589 0 0 1-.549-1.639l1.265-5.181v-.001a.318.318 0 0 0-.006-.168.287.287 0 0 0-.085-.132l-.002-.001-4.237-3.674A1.425 1.425 0 0 1 .75 8.503c.146-.49.568-.943 1.204-.986l5.535-.37a.198.198 0 0 0 .109-.042.244.244 0 0 0 .08-.112l.004-.012 2.06-5.393c.092-.258.259-.484.482-.646Z"
      clipRule="evenodd"
    />
  </svg>
);

export const ShareIconNew = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5 8.8125C15.4453 8.8125 14.4977 8.3542 13.8454 7.62588L9.26389 10.57C9.45592 11.0077 9.5625 11.4914 9.5625 12C9.5625 12.5086 9.45591 12.9924 9.26384 13.4301L13.8453 16.3742C14.4976 15.6458 15.4453 15.1875 16.5 15.1875C18.4675 15.1875 20.0625 16.7825 20.0625 18.75C20.0625 20.7175 18.4675 22.3125 16.5 22.3125C14.5325 22.3125 12.9375 20.7175 12.9375 18.75C12.9375 18.2414 13.0441 17.7577 13.2361 17.32L8.65461 14.3759C8.00232 15.1042 7.05468 15.5625 6 15.5625C4.03249 15.5625 2.4375 13.9675 2.4375 12C2.4375 10.0325 4.03249 8.4375 6 8.4375C7.05473 8.4375 8.0024 8.89585 8.6547 9.62424L13.2362 6.68013C13.0441 6.2424 12.9375 5.75865 12.9375 5.25C12.9375 3.28249 14.5325 1.6875 16.5 1.6875C18.4675 1.6875 20.0625 3.28249 20.0625 5.25C20.0625 7.21751 18.4675 8.8125 16.5 8.8125ZM14.0625 5.25C14.0625 3.90381 15.1538 2.8125 16.5 2.8125C17.8462 2.8125 18.9375 3.90381 18.9375 5.25C18.9375 6.59619 17.8462 7.6875 16.5 7.6875C15.6545 7.6875 14.9096 7.25705 14.4724 6.60335C14.4659 6.59136 14.4589 6.57952 14.4514 6.56785C14.4436 6.55581 14.4355 6.54415 14.427 6.5329C14.1959 6.16027 14.0625 5.72072 14.0625 5.25ZM8.07263 13.2835C8.0643 13.2945 8.05631 13.306 8.0487 13.3179C8.04132 13.3293 8.03442 13.341 8.02798 13.3528C7.59084 14.0068 6.84572 14.4375 6 14.4375C4.65381 14.4375 3.5625 13.3462 3.5625 12C3.5625 10.6538 4.65381 9.5625 6 9.5625C6.84544 9.5625 7.59036 9.99293 8.02755 10.6466C8.03411 10.6587 8.04116 10.6706 8.0487 10.6823C8.05647 10.6944 8.06463 10.7061 8.07314 10.7174C8.30414 11.0899 8.4375 11.5294 8.4375 12C8.4375 12.4709 8.30394 12.9107 8.07263 13.2835ZM14.4265 17.4679C14.1957 17.8404 14.0625 18.2796 14.0625 18.75C14.0625 20.0962 15.1538 21.1875 16.5 21.1875C17.8462 21.1875 18.9375 20.0962 18.9375 18.75C18.9375 17.4038 17.8462 16.3125 16.5 16.3125C15.6548 16.3125 14.9101 16.7427 14.4728 17.396C14.4662 17.4083 14.459 17.4204 14.4514 17.4323C14.4435 17.4446 14.4352 17.4565 14.4265 17.4679Z"
        fill="#6C5CE7"
      />
    </svg>
  );
};
